import { render, staticRenderFns } from "./verticalMenu.vue?vue&type=template&id=41e13d46&scoped=true"
import script from "./verticalMenu.vue?vue&type=script&lang=js"
export * from "./verticalMenu.vue?vue&type=script&lang=js"
import style0 from "./verticalMenu.vue?vue&type=style&index=0&id=41e13d46&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41e13d46",
  null
  
)

export default component.exports